import React from 'react';
import { gettext } from '@eb/i18n';

import ArrowRightChunkySVG from 'eventbrite_design_system/iconography/icons/ArrowRightChunky';
import Icon from 'eventbrite_design_system/icon/Icon';
import Link from 'eventbrite_design_system/link/Link';

import './HeaderTitle.scss';

const HeaderTitle = ({
    header: {
        shouldShowCustomContent,
        customContentTitle,
        customContentCtaLabel,
        customContentCtaLink,
        customLinkLabel,
        customCombinedHeaderTitleAndCta,
    },
    clickCTASeasonal,
}) => {
    let response = null;

    const _handleCtaOnClick = (e) => {
        e.preventDefault();

        clickCTASeasonal();

        if (window) {
            window.location = customContentCtaLink;
        }
    };

    if (shouldShowCustomContent) {
        const title = customContentTitle || 'Made for those who do';
        //Note: Use stylesheet to update appearance and don't modify below HTML unless necessary. Translation
        //leverages entire string (including HTML) as key in object lookup
        const titleText = gettext(
            `<div class="feed-header__title-top">${title}</div>`,
        );

        let displayTitle = (
            <>
                <div dangerouslySetInnerHTML={{ __html: titleText }} />

                <div
                    className="feed-header__title-bottom feed-header__title-bottom--seasonal"
                    data-spec="seasonal-title"
                >
                    {gettext('%(seasonalContent)s', {
                        seasonalContent: customContentCtaLabel,
                    })}
                </div>
            </>
        );

        if (customCombinedHeaderTitleAndCta) {
            displayTitle = (
                <div
                    dangerouslySetInnerHTML={{
                        __html: customCombinedHeaderTitleAndCta,
                    }}
                />
            );
        }

        response = (
            <h1 className="feed-header__title">
                {displayTitle}

                <div className="feed-header__cta-container">
                    <Link
                        aria-label={gettext('Go to %(seasonal)s events', {
                            seasonal: customContentCtaLabel,
                        })}
                        onClick={_handleCtaOnClick}
                        to={customContentCtaLink}
                        data-spec="seasonal-cta"
                    >
                        <div className="feed-header__cta-text eds-text-bm eds-text-weight--heavy eds-show-up-md">
                            {gettext('%(linkLabel)s', {
                                linkLabel: customLinkLabel,
                            })}
                        </div>
                        <Icon type={<ArrowRightChunkySVG />} size="small" />
                    </Link>
                </div>
            </h1>
        );
    } else {
        //Note: Use stylesheet to update appearance and don't modify below HTML unless necessary. Translation
        //leverages entire string (including HTML) as key in object lookup
        const title = gettext(
            '<div class="feed-header__title-top">Made for</div><div class="feed-header__title-bottom">those who do</div>',
        );

        response = (
            // eslint-disable-next-line react/no-danger
            <h1
                className="feed-header__title"
                dangerouslySetInnerHTML={{ __html: title }}
            />
        );
    }

    return response;
};

export default HeaderTitle;
